import { FormControl, FormGroup, Validators } from '@angular/forms';

export class RepoBusiness {
  repoBusinessId: number;
  address: string;
  businessName: string;
  
  addressLine2: string;
  stateName: string;
  countryName: string;
  postCode: string;
  suburb: string;
  website: string;
  contacts: ContactName[]=[];

  static asFormGroup(repoBusiness: RepoBusiness): FormGroup {
    const fg = new FormGroup({
      businessName: new FormControl(
        repoBusiness?.businessName,
        Validators.required
      ),
      address: new FormControl(repoBusiness?.address, Validators.required),
      addressLine2: new FormControl(repoBusiness?.addressLine2),
      stateName: new FormControl(repoBusiness?.stateName, Validators.required),
      countryName: new FormControl(
        repoBusiness?.countryName || '',
        Validators.required
      ),
      postCode: new FormControl(repoBusiness?.postCode, Validators.required),
      suburb: new FormControl(repoBusiness?.suburb, Validators.required),
      website: new FormControl(repoBusiness?.website, [
        Validators.required,
        Validators.pattern(
          '^(?:https?://)?(?:www.)?([a-zA-Z0-9-]+)(?:.[a-zA-Z]{2,})(?:.[a-zA-Z]{2,})+$'
        ),
      ]),
    });
    return fg;
  }
}
export class ContactName {
  prefix: string;
  fullName: string;
  repoContactId: number;
}

export class RepoBusinessSearchFields {
  businessName: string;
  address: string;
  suburb: string;
  stateName: string;
  postCode: string;
  countryName: string;
  website: string;
  //contacts: ContactName[];
}

export enum RepoBusinessTableFields {
  BUSINESS_NAME = 'businessName',
  ADDRESS = 'address',
  ADDRESS2 = 'ADDRESS2',
  WEBSITE = 'website',
  CONTACTS = 'contacts',
  SUBURB = 'suburb',
  STATE = 'stateName',
  POSTCODE = 'postCode',
  COUNTRY = 'countryName',
}

export class Position {
  positionId: number;
  positionName: string;
  isLinkedToContact: boolean;
  static asFormGroup(position: Position): FormGroup {
    const fg = new FormGroup({
      positionId: new FormControl(position?.positionId),
      positionName: new FormControl(
        position?.positionName,
        Validators.required
      ),
    });
    return fg;
  }
}

export class RepoContact {
  repoContactId: number;
  salutation: string;
  firstName: string;
  lastName: string;
  suffix: string;
  email: string;
  mobile: string;
  countryCode: string;
  phone: any;
  isReceiveRepoEmail: boolean;
  isReceiveRepoSMS: boolean;

  position: Position;
  repoBusiness: RepoBusiness;

  static asObject(
    formData: any,
    repoContactId: number,
    repoBusinessId: number
  ): RepoContact {
    const repoContact: RepoContact = {
        repoContactId: repoContactId,
        repoBusiness: {
            repoBusinessId: repoBusinessId,
            businessName: '',
            address: '',
            contacts: [],
            website: '',
            addressLine2: '',
            countryName: '',
            postCode: '',
            stateName: '',
            suburb: ''
        },
        position: { positionId: formData?.positionId, positionName: '',isLinkedToContact: false },
        salutation: formData?.salutation,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        suffix: formData?.suffix,
        email: formData?.email,
        countryCode: formData?.countryCode,
        mobile: formData?.mobile,
        isReceiveRepoEmail: formData?.isReceiveRepoEmail ?? false,
        isReceiveRepoSMS: formData?.isReceiveRepoSMS ?? false,
        phone: null
    };
    return repoContact;
  }
  static asFormGroup(repoContact: RepoContact): FormGroup {
    const fg = new FormGroup({
      repoContactId: new FormControl(repoContact?.repoContactId),
      salutation: new FormControl(
        repoContact?.salutation || ''
      ),
      firstName: new FormControl(repoContact?.firstName, Validators.required),
      lastName: new FormControl(repoContact?.lastName, Validators.required),
      suffix: new FormControl(repoContact?.suffix),
      email: new FormControl(repoContact?.email, [Validators.email]),
      phone: new FormControl(repoContact?.mobile),
      isReceiveRepoEmail: new FormControl(repoContact?.isReceiveRepoEmail),
      isReceiveRepoSMS: new FormControl(repoContact?.isReceiveRepoSMS),
      positionId: new FormControl(
        !repoContact || !repoContact?.position
          ? 0
          : repoContact?.position.positionId ?? 0
        
      ),
    });

    fg.get('isReceiveRepoEmail')?.valueChanges.subscribe((value) => {
      const emailCtrl = fg.get('email');
      emailCtrl?.markAsUntouched();
      if (value) {
        emailCtrl?.setValidators([Validators.required, Validators.email]);
      } else {
        emailCtrl?.setValidators([Validators.email]);
      }
      emailCtrl?.updateValueAndValidity();
    });

    // Dynamic mobile validation
    fg.get('isReceiveRepoSMS')?.valueChanges.subscribe((value) => {
      const mobileCtrl = fg.get('phone');
      mobileCtrl?.markAsUntouched();
      if (value) {
        mobileCtrl?.setValidators([Validators.required]);
      } else {
        mobileCtrl?.clearValidators();
      }
      mobileCtrl?.updateValueAndValidity();
    });

    // Run once at init so validators reflect the initial state
    fg.get('isReceiveRepoEmail')?.updateValueAndValidity({ emitEvent: true });
    fg.get('isReceiveRepoSMS')?.updateValueAndValidity({ emitEvent: true });
    return fg;
  }
}

export class RepoPosition {
  positionId: number;
  positionName: string;
  isLinkedToContact: boolean;

  static asObject(
    formData: any,
    positionId: number
  ): RepoPosition {
    const repoPosition: RepoPosition = {
        positionId: positionId,
        positionName: formData?.positionName,
        isLinkedToContact: formData?.isLinkedToContact,
    };
    return repoPosition;
  }
  static asFormGroup(repoPosition: RepoPosition): FormGroup {
    const fg = new FormGroup({
      positionId: new FormControl(repoPosition?.positionId),      
      positionName: new FormControl(repoPosition?.positionName, Validators.required),
      isLinkedToContact: new FormControl(repoPosition?.isLinkedToContact),
    });
    return fg;
  }
}
